import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Formik, Field, Form } from 'formik';
import { withTheme } from 'styled-components';
import { withRouter, Prompt } from 'react-router';
import { TextInput, Button } from '@01_people/ui-library';
import { withTranslation } from 'react-i18next';
import * as ActionCreators from '../../../redux/action';
import PasswordFormSchema from './password-form.schema';
import PaswordFormSC from './password-form.styled';

class PasswordForm extends React.PureComponent {
  constructor(props) {
    super(props);
    this.wrapperRef = React.createRef();
  }

  render() {
    const { updateUserPassword, toggleInfoModal, t } = this.props;
    return (
      <PaswordFormSC ref={this.wrapperRef}>
        <h5>{t('password.title')}</h5>

        <Formik
          initialValues={{
            currentPassword: '',
            newPassword: '',
            confirmPassword: ''
          }}
          validationSchema={PasswordFormSchema}
          onSubmit={(values, { setSubmitting, resetForm }) => {
            const data = values;

            data.callback = () => {
              setSubmitting(false);
              // animation issue, timeout needed
              setTimeout(() => resetForm(), 300);
            };

            data.button = {
              text: 'Ok',
              callback: toggleInfoModal
            };

            updateUserPassword(data);
          }}
          render={({
            values,
            setFieldValue,
            setFieldTouched,
            errors,
            touched,
            isSubmitting,
            dirty
          }) => (
            <Form>
              <Prompt when={dirty} message={t('password.leaveMessage')} />
              {/* {(errors.currentPassword && touched.currentPassword) ||
              (errors.newPassword && touched.newPassword) ||
              (errors.confirmPassword && touched.confirmPassword) ? (
                <ErrorInfo
                  errors={[
                    errors.currentPassword,
                    errors.newPassword,
                    errors.confirmPassword
                  ]}
                />
              ) : null} */}
              <div className="password">
                <div className="password-left">
                  <h6>{t('password.password.label')}</h6>
                  <p className="color-description">
                    {t('password.password.description')}
                  </p>
                </div>
                <div className="password-right">
                  <Field
                    type="password"
                    name="currentPassword"
                    label={t('password.password.form.currentPass')}
                    customClass="txt-inp"
                    component={TextInput}
                    defaultValue={values.currentPassword}
                    onChange={value => setFieldValue('currentPassword', value)}
                    onBlur={() => setFieldTouched('currentPassword', true)}
                    setTouched={value =>
                      setFieldTouched('currentPassword', value)
                    }
                    errors={
                      errors.currentPassword && touched.currentPassword
                        ? [t(errors.currentPassword)]
                        : []
                    }
                  />
                  <Field
                    type="password"
                    name="newPassword"
                    label={t('password.password.form.newPass')}
                    customClass="txt-inp"
                    component={TextInput}
                    defaultValue={values.newPassword}
                    onChange={value => setFieldValue('newPassword', value)}
                    onBlur={() => setFieldTouched('newPassword', true)}
                    setTouched={value => setFieldTouched('newPassword', value)}
                    errors={
                      errors.newPassword && touched.newPassword
                        ? [t(errors.newPassword)]
                        : []
                    }
                  />
                  <Field
                    type="password"
                    name="confirmPassword"
                    label={t('password.password.form.confirmPass')}
                    customClass="txt-inp"
                    component={TextInput}
                    defaultValue={values.confirmPassword}
                    onChange={value => setFieldValue('confirmPassword', value)}
                    onBlur={() => setFieldTouched('confirmPassword', true)}
                    setTouched={value =>
                      setFieldTouched('confirmPassword', value)
                    }
                    errors={
                      errors.confirmPassword && touched.confirmPassword
                        ? [t(errors.confirmPassword)]
                        : []
                    }
                  />
                </div>
              </div>
              <div className="save-wrapper">
                <Button
                  styling="primary"
                  label={t('password.password.form.saveButton')}
                  type="submit"
                  disabled={Object.keys(errors).length !== 0 || isSubmitting}
                />
              </div>
            </Form>
          )}
        />
      </PaswordFormSC>
    );
  }
}

PasswordForm.propTypes = {
  updateUserPassword: PropTypes.func.isRequired,
  toggleInfoModal: PropTypes.func.isRequired,
  location: PropTypes.shape({}).isRequired,
  t: PropTypes.func.isRequired
};

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      updateUserPassword: ActionCreators.updateUserPassword,
      toggleInfoModal: ActionCreators.toggleInfoModal
    },
    dispatch
  );

export default withTranslation('pages')(
  withRouter(
    connect(
      undefined,
      mapDispatchToProps
    )(withTheme(PasswordForm))
  )
);
